const panelTemplates = {
    header: (headline, html) => {
        return html`<span role="heading" aria-level="2" class="form-label d-block">${headline}</span>`;
    }
}


export default panelTemplates;
